import createValidate from 'utils/validation';

export default createValidate({
  value: {
    numeric: true,
  },
});
